require('fslightbox');

(function() {
    const handleProjects = () => {
        window.addEventListener("click", (e) => {
            if (e.target.classList.contains("talent__work-menu-button")) {
                const buttons = document.querySelectorAll(".talent__work-menu-button");
                const projects = document.querySelectorAll(".talent__work-gallery");
                const videoProjects = document.querySelector("#video-projects");
                console.log("button click");
                
                const target = e.target.getAttribute("data-target");
                const activeProject = document.querySelector(`#${target}`);

                console.log(target);
                console.log(activeProject);
    
                projects.forEach((project) => {
                    project.classList.remove("show");
                });
                videoProjects.classList.remove("show");
    
                buttons.forEach((button) => {
                    button.classList.remove("expanded");
                });
                e.target.classList.add("expanded");
    
                activeProject.classList.add("show");
            }
        });
    }
    
    handleProjects();
})();